import type { SuggestAdressesQueryResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { adresses } from '~/msw/mocks/adresse/adresses'

export function suggestAdressesHandler() {
  return http.get<never, never, SuggestAdressesQueryResponse>('http://localhost:3000/api/v1/adresses', ({ request }) => {
    const search = (new URL(request.url).searchParams.get('search') ?? '').toLowerCase()
    if (search.trim().length < 3)
      return HttpResponse.json([])

    const mots = search.split(/\s+/).filter(Boolean)
    const matches = adresses.filter(adresse => mots.every(mot => adresse.label.toLowerCase().includes(mot)))
    return HttpResponse.json(matches)
  })
}
